import * as React from "react";

import type {TeacherAccessPermissionsResult} from "./queries/use-teacher-access-permissions-query.ts";

export const EmptyTeacherAccessPermissionsResult: TeacherAccessPermissionsResult =
    {
        status: "loading",
        data: null,
    };

// All component children of Coach should use TeacherAccessPermissionsContext.
export const TeacherAccessPermissionsContext: React.Context<TeacherAccessPermissionsResult> =
    React.createContext<TeacherAccessPermissionsResult>(
        EmptyTeacherAccessPermissionsResult,
    );
TeacherAccessPermissionsContext.displayName = "TeacherAccessPermissionsContext";
